import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Collapse } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons'
import { createWebSearchItemAction } from '../../../store/web-search'
import WebSearchResultTable from '../WebSearchResultTable'
import { calcLastWebSearchItem, searchInfoText } from '../web-search-utils'
import { ProtectedAccess } from '../../RoleBasedAccess'

const { Panel } = Collapse

const WebSearchPanel = ({ app_item, onUpdate = {} }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const createWebSearchItem = useCallback(
    async (app_item) => {
      setLoading(true)
      try {
        const response = await dispatch(createWebSearchItemAction({ app_item })).unwrap()
        updateWebSearchItem(response)
      } finally {
        setLoading(false)
      }
    },
    [app_item]
  )

  const updateWebSearchItem = useCallback(
    (newItem) => {
      const itemExists = app_item.web_search_items.some((item) => item.id === newItem.id)

      if (!itemExists) {
        const updated = {
          ...app_item,
          web_search_items: [...app_item.web_search_items, newItem],
        }
        onUpdate(updated)
      }
    },
    [app_item]
  )

  const buildExtra = (lastWebSearchItem) => {
    return (
      (!lastWebSearchItem || lastWebSearchItem.current_state === 3) && (
        <ProtectedAccess allowedRoles={['project_manager']}>
          <Button loading={loading} icon={<PlayCircleOutlined />} onClick={() => createWebSearchItem(app_item)}>
            Запустить поиск
          </Button>
        </ProtectedAccess>
      )
    )
  }

  const lastWebSearchItem = useMemo(() => calcLastWebSearchItem(app_item.web_search_items), [app_item.web_search_items])

  const webSearchPanelHeader = useMemo(() => {
    const info = searchInfoText(lastWebSearchItem, app_item.estimate_field)
    return info?.text
  }, [lastWebSearchItem, app_item.estimate_field])

  return (
    <Collapse>
      <Panel header={'Web-поиск: ' + webSearchPanelHeader} key="web-search" extra={buildExtra(lastWebSearchItem)}>
        <WebSearchResultTable
          results={lastWebSearchItem?.payload_response?.results}
          estimatePrice={app_item?.estimate_field?.price}
        />
      </Panel>
    </Collapse>
  )
}

export default WebSearchPanel
